import { Autocomplete, TextField } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'

type SmartAutoCompleteProps = {
  control?: any
  name: string
  options: any[]
  rest?: any
  label?: string
  getOptionLabel?: (option: any) => string
  onCreate?: (text: string) => any
  disableClearable?: boolean
}

const AutoComplete = ({
  control,
  options,
  name,
  label,
  onCreate,
  disableClearable,
  ...rest
}: SmartAutoCompleteProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ...fieldProps }, fieldState: { error } }) => {
        return (
          <Autocomplete
            freeSolo
            id={`${name}-select`}
            defaultValue={''}
            {...rest}
            {...fieldProps}
            onChange={(event, newValue) => {
              if (typeof newValue === 'string') {
                fieldProps.onChange(newValue)
              } else if (newValue && newValue.inputValue) {
                // Create a new value from the user input
                if (onCreate) {
                  fieldProps.onChange(onCreate(newValue.inputValue))
                }
              } else {
                fieldProps.onChange(newValue)
              }
            }}
            options={options}
            renderInput={(params) => (
              <TextField
                {...params}
                error={Boolean(error?.message)}
                helperText={error?.message ? error?.message : rest?.helperText}
                label={label}
              />
            )}
            sx={{ flex: '1' }}
            disableClearable={disableClearable}
          />
        )
      }}
    />
  )
}

export default AutoComplete
